import { Box, Skeleton } from '@mui/material'

export const MentionSkeletonList = () => {
  return (
    <Box>
      {[0, 1, 2, 3].map((i) => (
        <Skeleton variant="rounded" key={i} height={100} width="100%" sx={{ mb: 4 }} />
      ))}
    </Box>
  )
}
